module.exports = __webpack_public_path__ + "static/media/05-09.864637f7.png";